module.exports = __webpack_public_path__ + "img/86e6932.svg";